import axios from "axios";
import React, { useContext, useEffect, useRef, useState } from "react";
import { BlockchainContext } from "../../Context/BlockchainContext";
import "./Certificates.css";
import html2canvas from "html2canvas";
import { v4 as uuidv4 } from "uuid";
import { BigNumber, ethers } from "ethers";
import swal from "sweetalert";
import { mintAddressTestnet2 } from "../../utils/constant";
import CertificateMintDetail from "./CertificateMintDetail";
import { Button } from "react-bootstrap";
import { useNavigate, useParams } from "react-router-dom";
import { UserContext } from "../../Context/UserContext";
import { ArrowBack } from "@mui/icons-material";

const Certificates = () => {
  const { coursename, from, to, serial, certificateno } = useParams();
  console.log(coursename, from, to, serial, certificateno, "GOTTEN PARAMS");
  const [certificateDetails, setCertificateDetails] = useState({});
  const [details, setDetails] = useState({});
  const [refetch, setRefetch] = useState(false);
  const [serialNumber, setSerialNumber] = useState("");

  const navigate = useNavigate();
  const { user, setRequestLoading, mintNFTTestnetBNB, signBuyFunction } =
    useContext(BlockchainContext);
  const { data } =
    useContext(UserContext);
  const [img, setImg] = useState("");

  let newDate = new Date();
  let dd = String(newDate.getDate()).padStart(2, "0");
  let mm = String(newDate.getMonth() + 1).padStart(2, "0"); //January is 0!
  let yyyy = newDate.getFullYear();

  newDate = dd + "/" + mm + "/" + yyyy;

  // const dateObj = new Date(details?.fromDate);
  // const day = dateObj.getUTCDate();
  // const month = dateObj.getUTCMonth() + 1; // Add 1 to month value as month index starts from 0
  // const year = dateObj.getUTCFullYear();
  // const formattedFromDate = `${day}/${month}/${year}`;

  const splitedFromDate = details?.fromDate?.split(" ")?.[0];

  const todateObj = new Date(details?.date);
  const today = todateObj.getUTCDate();
  const tomonth = todateObj.getUTCMonth() + 1; // Add 1 to month value as month index starts from 0
  const toyear = todateObj.getUTCFullYear();
  const formattedToDate = `${today}/${tomonth}/${toyear}`;

  const certificateTemplate = useRef();
  const certificateWrapper = useRef();

  useEffect(() => {
    const data1 = async () => {
      await axios
        .get(
          `https://backend.studyswiftly.com/api/certificate/email/${user.email}`
        )
        .then((res) => {
          setDetails(res.data.result);
        });
    };
    data1();
  }, []);

  // get certificate details
  useEffect(() => {
    const data = async () => {
      await axios
        .get(
          `https://backend.studyswiftly.com/api/v1/mint-certificate/data/${user?.email}`
        )
        .then((res) => {
          setCertificateDetails(res.data[0]);
        });
    };
    data();
  }, [refetch]);

  // console.log(certificateDetails,"ee")
  // const priceByToken = 0 ;

  const mintCertificate = async () => {
    console.log(user?._id);
    console.log("clicked.......................");
    const generateId = Math.floor(Math.random() * 1000000000000);

    setRequestLoading(true);
    const dataUrl = img;
    const data = new FormData();
    data.append("file", dataUrl);
    data.append("id", generateId.toString());
    data.append("price", "0");
    data.append("tokenAddress", "0x0000000000000000000000000000000000000000");
    data.append("refAddress", "0x0000000000000000000000000000000000000000");
    data.append("nonce", uuidv4());
    data.append("certificateno", "Sample");
    data.append("name", user?.name);
    data.append("email", user?.email);
    data.append("walletAddress", user?.walletAddress);
    data.append("date", newDate);
    data.append("serial", "Sample");
    data.append("description", "Sample");
    data.append("coursename", "Sample");

    await axios
      .post(
        "https://backend.studyswiftly.com/api/v1/mint-certificate/uri-json-nft",
        data,
        {}
      )
      .then(async (res) => {
        let Obj = {};

        if (res.status === 200) {
          console.log("cliced.................33332222222222");
          const data1 = await signBuyFunction(
            generateId.toString(),
            ethers.utils.parseEther("0"),
            "0x0000000000000000000000000000000000000000",
            "0x0000000000000000000000000000000000000000",
            "0x0000000000000000000000000000000000000000",
            "0x0000000000000000000000000000000000000000",
            "0x4c17f3c856d1d059bdd597ad64d0f4375e52944d",
            "0",
            "0",
            "0",
            "0",
            res.data.uri
          );

          //   if (token === "bnb") {
          Obj = await mintNFTTestnetBNB(data1);
          //   }

          data.append("tokenId", Obj.ID);
          data.append("minthast", Obj.mint_hash);
          data.append(
            "contactAdd",
            "0x2995E3bd041E4C737537f033ca608713414E0e3e"
          );

          await axios
            .post(
              "https://backend.studyswiftly.com/api/v1/mint-certificate/save-nft",
              data,
              {}
            )
            .then((res) => {
              if (res.status === 200) {
                setRequestLoading(false);
                const wrapper = document.createElement("div");
                wrapper.innerHTML = `
                    <a href=${Obj.mint_hash} target="_any" className="link_hash">${Obj.mint_hash}</a>
                    <br/>
                    <p>Use the following information to import the NFT to your wallet</p>
                    <p className="address">Contract Address: <br/><span style="color: yellow;">0x2995E3bd041E4C737537f033ca608713414E0e3e</span></p>
                    <p className="address">Token ID: <br/><span style="color: yellow;">${Obj.ID}</span></p>
                    `;
                swal({
                  title: "Minted",
                  content: wrapper,
                  icon: "success",
                  button: true,
                  className: "modal_class_success",
                });
                setRefetch(!refetch);
                //   .then((willDelete) => {
                //     if (willDelete) {
                //       navigate(`/mintednft/${Obj.ID}/${mintAddressTestnet2}`)
                //     } else {
                //       console.log("good job")
                //     }
                //   });
                // console.log(res.data, "res.data")
                // handleSubmit(Obj.ID, priceByToken, res.data.certificateImg)
                // // handleSubmit(Obj.ID, priceByToken, img)
              }
            })
            .catch((err) => {
              console.log(err);
              setRequestLoading(false);
              const wrapper = document.createElement("div");
              wrapper.innerHTML = `<a href="" target="_any" className="link_hash"></a> <br/> <p className="success"><b>You have successfully minted but error in while saving data.<b></p>`;
              swal({
                title: "Warning",
                content: wrapper,
                icon: "warning",
                button: "OK",
                className: "modal_class_success",
              });
            });
        }
      })
      .catch((err) => {
        console.log(err);
        setRequestLoading(false);
        if (err.code === 4001) {
          return swal({
            title: "Failed",
            text: "Minting Failed!",
            icon: "warning",
            button: "OK",
            dangerMode: true,
            className: "modal_class_success",
          });
        }
        return swal({
          title: "Attention",
          text: "Something went wrong. Check your balance and try again later.",
          icon: "warning",
          button: "OK",
          dangerMode: true,
          className: "modal_class_success",
        });
      });
  };

  const exportAsImage = async (element, imageFileName) => {
    const canvas = await html2canvas(element, {
      allowTaint: true,
      useCORS: true,
    });
    const image = canvas.toDataURL("image/jpeg", 1.0);
    // download the image
    // console.log(image, "img")
    setImg(image);
  };
  useEffect(() => {
    exportAsImage(certificateTemplate.current, "heelo");
  }, []);

  useEffect(() => {
    if (details !== {} && details?.Serial) {
      let serialNo;
      console.log("Serial No : " + details.Serial);
      if (details.Serial < "10") {
        serialNo = "100000" + details.Serial;
      } else if (details.Serial < "100") {
        serialNo = "10000" + details.Serial;
      } else if (details.Serial < "1000") {
        serialNo = "1000" + details.Serial;
      } else if (details.Serial < "10000") {
        serialNo = "100" + details.Serial;
      } else if (details.Serial < "100000") {
        serialNo = "10" + details.Serial;
      } else {
        serialNo = details.Serial;
      }
      setSerialNumber(serialNo);
    } else {
      setSerialNumber("Sample");
    }
  }, [details]);

  return (
    <div style={{ background: "#151515" }}>
    <div className="container">
       <p className='cursor-pointer' style={{ cursor: "pointer",paddingTop:"20px" }} title='Back' onClick={() => navigate(-1)}><ArrowBack /></p>
      <div className="container certificateDiv " ref={certificateWrapper}>
        <div className={from=="sample"?"backgroundImag":"backgroundImag1"}  ref={certificateTemplate}>
          <div className="absoluate_wrapper">
            <h6 className="certificateNo capitalized">{certificateno}</h6>
            <h2 className="StudentName">{data?.name}</h2>
            <p
              className="certificateDis"
              // style={{ fontSize: "8px", paddingTop: "2px" }}
            >
              {coursename}
            </p>
            <p className="certificatedateForm">{from}</p>
            <p className="certificatedateTo">{to}</p>
            <p className="dateCer">{newDate}</p>
            <p className="SerialCer">{serial}</p>
          </div>
        </div>
      </div>
      <div className="text-center" style={{ paddingBottom: "30px" }}>
        <button
          className="backBtn mb-5 mt-5"
          onClick={() => navigate("/my-account", { state: { name: 2 } })}>
          BACK
        </button>
      </div>
      {/* {certificateDetails?.email ?(
        <CertificateMintDetail certificateDetails={certificateDetails} />
      ) : (
        <div className="mintBntnDiv">
          <button
            className="backBtn mb-5 mt-5"
            onClick={() => navigate("/my-account", { state: { name: 2 } })}
          >
            BACK
          </button>
          <button
            className="profileEnrolBtnMint mb-5 mt-5"
            onClick={mintCertificate}
          >
            MINT NOW
          </button>
        </div>
      )} */}
    </div>
    </div>
  );
};

export default Certificates;
